<template>
  <div class="modal popup" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <div>
            <h2 class="modal-title">{{ popup.content.title }}</h2>
            <p>{{ popup.content.subTitle }}</p>
          </div>
          <ButtonElement @click="closePopup" class="btn--ms btn--close btn--regular">
            <LucideIcon icon="X"/>
          </ButtonElement>
        </div>

        <div class="modal-body">
          <div v-html="popup.content.message"></div>
          <div v-if="popup.hasInputBox">
            <input
                ref="inputField"
                type="text"
                v-model="inputModel"
            />
          </div>
        </div>

        <div class="modal-footer">
          <ButtonElement @click="closePopup" class="btn--ms btn--silent btn--regular">Cancel</ButtonElement>
          <template v-if="!!popup.callback?.function">
            <ButtonElement @click="clickOnCallbackButton"
                           :class="!!popup.callback?.buttonClass? popup.callback?.buttonClass : 'btn--ms btn--danger'"
            >
              {{ popup.callback?.content }}
            </ButtonElement>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapState} from "pinia";
import {useGeneralStore} from "@shared/stores/general.store";
import {ButtonElement} from '@shared/components/elements';

export default defineComponent({
  name: 'PopupTemplate',
  components: {
    ButtonElement
  },
  data() {
    return {
      inputModel: ''
    };
  },
  setup() {
    // initialize the store
    const generalStore = useGeneralStore()
    return {generalStore}
  },
  computed: {
    ...mapState(useGeneralStore, ['popup'])
  },
  mounted() {
    if (this.generalStore.popup.hasInputBox) {
      this.$nextTick(() => {
        const inputField: HTMLInputElement = <HTMLInputElement>this.$refs.inputField;
        inputField.focus();
      });
    }
  },

  methods: {
    closePopup(): void {
      if (typeof this.generalStore.popup.beforeClose === 'function') {
        this.generalStore.popup.beforeClose(); // Call `beforeClose` function if defined
      }
      this.generalStore.closePopup();
    },
    clickOnCallbackButton(): void {
      this.generalStore.popup.callback?.function(this.inputModel);
      if (this.generalStore.popup.static) {
        this.generalStore.closePopup();
      }
    }
  }
});

</script>

<style lang="scss" scoped>
.popup {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 250ms ease 0s;

  .modal-dialog {
    min-width: 580px;

  }

  .modal-content {
    background-color: var(--card-bg);
    border-radius: $br-sm;
    border: 0;
    animation: slideTop 0.4s cubic-bezier(0.215, 0.610, 0.355, 1.000) forwards;
  }

  .modal-header {
    text-align: left;
    border: 0;
    padding: var(--space-32) var(--space-32) var(--space-16);
    justify-content: space-between;

    p {
      margin-bottom: var(--space-0);
      color: var(--text-neutral);
    }

  }

  .modal-body {
    text-align: left;
    padding: var(--space-0) var(--space-32);
    font-size: var(--fs-14);

    p {
      display: flex;
      font-size: var(--fs-14);
      margin-bottom: var(--space-8);
    }
  }

  .modal-footer {
    display: flex;
    border: 0;
    padding: var(--space-20) var(--space-32) var(--space-20);
    gap: var(--space-8);
  }
}

</style>
